import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HeadlineModal from './HeadlineModal';
import './HeadlineAnalysis.css';

class HeadlineAnalysis extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false
    };
    this.hideModalHandler = this.hideModalHandler.bind(this);
  }

  scoreClass() {
    const score = this.props.analysis.overall_score;
    if (score > 70) {
      return 'above-average';
    } else if (score > 50) {
      return 'average';
    } else {
      return 'below-average';
    }
  }

  scoreTitle() {
    const score = this.props.analysis.overall_score;
    if (score > 70) {
      return 'Above Avg';
    } else if (score > 50) {
      return 'Avg';
    } else {
      return 'Below Avg';
    }
  }

  hideModalHandler() {
    this.setState({ modalOpen: false });
  }

  render() {
    return (
      <div className="headline-analyzer" data-testid="headline-analysis">
        <div className="overall-score">
          <div className="name txt-knight-light headline-analyzer__title">
            Headline Quality Score
          </div>
          <i
            className="ss-icon ss-info"
            popover-placement="bottom"
            popover-trigger="mouseenter"
            popover="The Headline Quality Score is based on a multivariate linguistic algorithm built on the principles of Behavior Model theory and Sharethrough's neuroscience and advertising research."
          />
          <div className="score-wrapper">
            <div className={`score ${this.scoreClass()}`}>
              {this.props.analysis.overall_score} {this.scoreTitle()}
            </div>
          </div>
          <div className="tips">
            <div
              role="presentation"
              onClick={() => {
                this.setState({ modalOpen: true });
              }}
            >
              <i className="ss-icon ss-list" />
              <span className="expand">See Tips</span>
            </div>
          </div>

          <HeadlineModal
            modalOpen={this.state.modalOpen}
            hideModalHandler={this.hideModalHandler}
            analysis={this.props.analysis}
            scoreTitle={this.scoreTitle()}
            scoreClass={this.scoreClass()}
          />
        </div>
      </div>
    );
  }
}

HeadlineAnalysis.propTypes = {
  analysis: PropTypes.shape({
    overall_score: PropTypes.number.isRequired,
    strengths: PropTypes.arrayOf(PropTypes.object).isRequired,
    suggestions: PropTypes.arrayOf(PropTypes.object).isRequired
  }).isRequired
};

export default HeadlineAnalysis;
